import React from "react";
import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Button, type FormInstance, Tag } from "antd";
import "./data_cash_invoice.css";
import { withDataCashInvoiceDetailLogic, type MappedDataType } from "../../components/hoc_data_cash_invoice";

interface DataCashInvoiceProps {
    form: FormInstance;
    currentRecord: MappedDataType | null;
    handleVerify: () => Promise<void>;
    handleUpdate: () => Promise<void>;
}

interface DataCashInvoiceProps {
    form: FormInstance;
    currentRecord: MappedDataType | null;
    handleVerify: () => Promise<void>;
}

const DataCashInvoice: React.FC<DataCashInvoiceProps> = ({ form, currentRecord, handleVerify, handleUpdate }) => {

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };


    return (

        <div id="iau9" style={transformStyle}>

            <div className="gjs-grid-row" id="ihok6">
                <div className="gjs-grid-column" id="i92s8">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/browser_data_cash_invoice",
                                title: (
                                    <>
                                        <span>Browser Data Invoice</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/data_cash_invoice",
                                title: "Data Cash Invoice",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="dfrfsd">
                <div className="gjs-grid-column" id="sdfrs">
                    <Button
                        className="gr-button"
                        onClick={handleVerify}
                 disabled={currentRecord?.verifikasi === '1' || currentRecord?.statusInvoice === '2'}
                 style={
                     (currentRecord?.verifikasi === '1' || currentRecord?.statusInvoice === '2')
                         ? { opacity: 0.6, cursor: 'not-allowed' }
                         : {}
                 }
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Verifikasi
                    </Button>
                    <Button className="gr-button" onClick={handleUpdate}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Perbarui
                    </Button>
                </div>
            </div>

            <div className="gjs-grid-row" id="i42ln">
                <div className="gjs-grid-column" id="i3wyl">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 520 }}
                        labelCol={{ style: { width: '170px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Verifikasi"
                            style={{
                                marginBottom: "5px",
                                width: "60%",
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Form.Item name="verifikasi" noStyle>
                                    <Input placeholder="" />
                                </Form.Item>
                                <Form.Item
                                    noStyle
                                    dependencies={['verifikasi']}
                                >
                                    {({ getFieldValue }) => {
                                        const status = getFieldValue('verifikasi');
                                        switch (status) {
                                            case '1':
                                                return <Tag color="green" style={{ fontSize: '14px' }}>Active</Tag>;
                                            case '2':
                                                return <Tag color="yellow" style={{ fontSize: '14px' }}>Recalculate</Tag>;
                                            case '3':
                                                return <Tag color="red" style={{ fontSize: '14px' }}>Deactive</Tag>;
                                            default:
                                                return null;
                                        }
                                    }}
                                </Form.Item>
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Status Invoice"
                            name="status_invoice"
                            style={{
                                marginBottom: "5px",
                                width: "66%",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Receipt No."
                            name="receipt_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Date Create"
                            name="date_created"
                            style={{
                                marginBottom: "5px",
                                width: "66%",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Date Verifiy"
                            name="date_verify"
                            style={{
                                marginBottom: "5px",
                                width: "66%",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Transaction to"
                            name="transaction_to"
                            style={{
                                marginBottom: "5px",
                                width: "40%"
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Invoice No"
                            name="no_invoice"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Customer Code"
                            name="customer_code"
                            style={{
                                marginBottom: "5px",
                                width: "66%",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Customer Name"
                            name="customer_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Address"
                            name="address"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input.TextArea rows={4} placeholder="Enter your Address here..." />
                        </Form.Item>
                        <Form.Item
                            label="Salesman"
                            name="salesman"
                            style={{
                                marginBottom: "5px",
                                width: "76%",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="TOP"
                            name="top"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Remark"
                            name="remark"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input.TextArea rows={4} placeholder="Enter your Remark here..." />
                        </Form.Item>
                        <Form.Item
                            label="Amount Invoice"
                            name="invoice_amount"
                            style={{
                                marginBottom: "5px", width: "60%",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Amount Payment"
                            name="saldo_payment"
                            style={{
                                marginBottom: "5px", width: "60%",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Balance Credit"
                            name="saldo_akhir"
                            style={{
                                marginBottom: "5px", width: "60%",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default withDataCashInvoiceDetailLogic(DataCashInvoice);